import './components/ga-events';          //should be on top of each page's JS file
import "./components/wizcase-ad-cookies";
import "./parts/ppc/prequalify-modal";    // should be as soon as possible
import "./components/swipe-for-more";     // should be as soon as possible
import "./widgets/business-types";        // should be as soon as possible
import "./parts/navigation";
import "./parts/keyboard-navigation";
import "./parts/accept-cookies";
import "./components/blocker-logger";
import Tooltips from "./components/tooltips";

import "./components/ui-fixes";
import "./components/js-links";
import "./components/bing-events";
import "./components/show-qr-code";
import "./components/svg";
import "../vendor/splide.min";
import "./widgets/styleable-selects";
import './widgets/read-more';
import AnimatedReadMore from "./components/animated-read-more";
import "./widgets/tabs";
import "./widgets/promocode";

import ScoreTooltip from "./components/score-tooltip";
import "./widgets/accordion";
import "./components/scroll-top-btn";
import "./components/test-location";
import "./components/accessibility-widget";
import "./components/vendors-show-hide";
import "./parts/ppc/ai-summary";
import "./components/faq";

import PpcFilter from './parts/ppc/filter/PpcFilter';
import PpcFilterMobilePopup from './parts/ppc/filter/PpcFilterMobilePopup';
import ExitPopup from "./components/exit-popup";

import $ from "cash-dom";
import TipSection from './parts/ppc/tip-section/TipSection';
import StickyBanner from "./parts/sticky-banner";
import ContentSection from './parts/ppc/ContentSection';
import DeviceSizes from './components/DeviceSizes';
import ZeroResultsHandler from './parts/ppc/filter/ZeroResultsHandler';
import MidChartBanner from './parts/ppc/MidChartBanner';
import StartupPrequel from './parts/ppc/StartupPrequel';
import VendorsPodium from './parts/ppc/VendorsPodium';
import VendorsListCarousel from './parts/ppc/VendorsListCarousel';
import PpcFilteredItems from './parts/ppc/filter/PpcFilteredItems';
import VendorsReadMoreHandler from './parts/ppc/VendorsReadMoreHandler';
import PpcPageOrderEventSender from './parts/ppc/PpcPageOrderEventSender';
import BulletsLimitHandler from './parts/ppc/BulletsLimitHandler';
import Recaptcha from './components/recaptcha';
import AnimatedLine from './components/AnimatedLine';
import AnimatedCounter from './components/AnimatedCounter';
import AnimatedTipText from './components/AnimatedTipText';
import StorySlider from './parts/ppc/StorySlider';
import SnakeBorderAnimation from './components/SnakeBorderAnimation';
import CustomSelect from './components/custom-select';

/**
 * Dynamic module loading
 */
function initDynamicModules() {
    if (document.querySelector('.quiz-ui, .tiktok-quiz-ui, .ai-quiz-ui, .quiz-tiktok-social-ui, .quiz-us-social-1-ui, .ai-compact-quiz-ui')) {
        import('./parts/ppc/quiz').catch((err) => {
            console.error('Failed to dynamically load quiz module:', err);
        });
    }
}

initDynamicModules();

if ($('#posts_carousel').length > 0) {
    new Splide('#posts_carousel').mount();
}

if ($('#top_3_carousel').length > 0) {
    new Splide('#top_3_carousel').mount();
}

if ($('#myth_carousel').length > 0) {
    new Splide('#myth_carousel').mount();
}

$('.trustpilot-reviews-slider').each(function (i, element) {
    new Splide('#' + $(element).attr('id')).mount();
});

$('.user-reviews-slider').each(function (i, element) {
    // options come from the data-splide attribute utils\html\Carousel writes
    const slider = new Splide('#' + $(element).attr('id'));
    const current = $(element).closest('.user-reviews').find('.user-reviews__counter-current');

    // `move` fires before the transition and carries the index it is moving to; splide.index is
    // still the old one at that point, so take the argument and fall back to it only on `mounted`,
    // which passes none
    const showIndex = function (index) {
        current.text((typeof index === 'number' ? index : slider.index) + 1);
    };

    slider.on('mounted', showIndex);
    slider.on('move', showIndex);

    slider.mount();
});

if ($('.vendor-logos-carousel').length > 0) {

    const sliders = document.querySelectorAll('.vendor-logos-carousel');

    const splideOptions = {
        type: 'loop',
        perPage: 4,
        pagination: false,
        autoplay: true,
        interval: 0,
        speed: 3000,
        rewind: true,
        arrows: false,
        focus: 'center',
        breakpoints: {
            640: {
                perPage: 3,
            }
        },
    };

    sliders.forEach(slider => {
        new Splide(slider, splideOptions).mount();
    });
}

if ($('.trust-building-splide').length > 0) {
    const trustBuildingSliderOptions = {
        type: 'loop',
        focus: 'center',
        perPage: 1,
        fixedWidth: '52%',
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 2500,
        speed: 500,
        pauseOnHover: false,
        pauseOnFocus: false,
        trimSpace: false,
        drag: false,
    };

    document.querySelectorAll('.trust-building-splide')
        .forEach((slider) => new Splide(slider, trustBuildingSliderOptions).mount());
}

$(function () {
    Recaptcha.init();
    ExitPopup.init();
    Tooltips.getInstance().initOnce();
    AnimatedReadMore.getInstance().init();
    ZeroResultsHandler.init();
    VendorsPodium.getInstance().init();
	CustomSelect.init();

    const ppcFilter = PpcFilter.getInstance();
    ppcFilter.init();

    BulletsLimitHandler.getInstance().init();

    //TipSection.getInstance().init();
    StickyBanner.getInstance().init();
    MidChartBanner.getInstance().init();
    StartupPrequel.getInstance().init();

    new VendorsReadMoreHandler().init();
    new VendorsListCarousel('vendors-list-splide-carousel').init();
    new PpcFilteredItems({
        $vendorsListContainer: $('.duplicated-list-holder'),
        defaultVisibleVendorsCount: 3,
    }).init();
    new PpcFilteredItems({
        $vendorsListContainer: $('.vendor-reviews-list'),
        defaultVisibleVendorsCount: Infinity,
        singleVendorSelector: '.ppc-single-vendor-review',
    }).init();

    const coupon = new ContentSection('.coupon-container');
    coupon.init();

    setTimeout(function () {
        const ppcFilterMobilePopup = PpcFilterMobilePopup.getInstance(ppcFilter.getActiveFilters());

        initPpcFilterMobile();

        $(window).on('resize', function () {
            initPpcFilterMobile();
        });

        $(document).on('PrequalifyModalHandler:prequalFilterApply', function () {
            ppcFilterMobilePopup.initialFilters = ppcFilter.getActiveFilters();
        });

        function initPpcFilterMobile() {
            const maxWidth = DeviceSizes.MD;

            if (window.innerWidth < maxWidth) {
                ppcFilterMobilePopup.init();
                ppcFilterMobilePopup.showFilterButton();
            } else {
                ppcFilterMobilePopup.hideFilterButton();
            }
        }
    }, 0);

    // should be last
    PpcPageOrderEventSender.getInstance().handle();

    ScoreTooltip.init();

    const animatedTypingContainer = document.querySelector('.animated-line');
    if (animatedTypingContainer) {
        new AnimatedLine(animatedTypingContainer).start();
    }

    document.querySelectorAll('.animated-counter')
        .forEach((element) => new AnimatedCounter(element).start());

    document.querySelectorAll('.animated-tip-text')
        .forEach((element) => new AnimatedTipText(element).start());

    StorySlider.initAll();

    SnakeBorderAnimation.init();
});
